/* ----------------------------------------------------- */
/* ----------------------- FRONT ----------------------- */

// CSS
import "./scss/theme.scss";

// JS
import "./js/theme.js";
var element =  document.querySelector('.home-hero');
if (typeof(element) != 'undefined' && element != null) {
  import('./js/particles.js')
}